import * as React from 'react';
const NavContext = /*#__PURE__*/React.createContext(null);
NavContext.displayName = 'NavContext';
export default NavContext;